import { SCREEN_SIZES } from '@ui-screen/config'

export enum SliderScreenSizes {
  xs = SCREEN_SIZES.xs,
  s = SCREEN_SIZES.s,
  m = SCREEN_SIZES.m,
  l = 1240,
  xl = SCREEN_SIZES.xl
}
